<template>
  <div class="py-3">
    <div class="d-flex align-center">
      <v-icon>mdi-menu</v-icon>
      <h3 class="ml-2">{{ group.name }}</h3>
      <div class="d-flex flex-1 flex-grow-1">
        <v-divider class="my-2 mx-2" />
        <v-icon @click="removeGroup">
          mdi-close
        </v-icon>
      </div>
    </div>
    <div
      v-for="(groupDocument, index) in group.documents"
      :key="index"
      class="ma-2"
    >
      {{ groupDocument.name }}
      <div class="mt-2">
        <FileComponent
          class="pb-2"
          v-for="file in [
            groupDocument.sourceDocument,
            groupDocument.responseDocument
          ].filter(Boolean)"
          :key="file.id"
          :file="file"
          :fileTypes="['application/pdf']"
          @show="showFile(file)"
          customActions
          disabled
          showFileName
        />
      </div>
    </div>
    <PDFViewFull :data="fileDialog" />
    <AddFileToOfferGroupAction :offerGroupId="group.id" />
  </div>
</template>

<script>
import PDFViewFull from "@/components/common/PDFViewFull";
import FileComponent from "@/components/common/FileComponent";
import AddFileToOfferGroupAction from "@/views/offers/actions/AddFileToOfferGroupAction";
import { getFilePreviewSettings } from "@/utils/files";

export default {
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  components: {
    PDFViewFull,
    FileComponent,
    AddFileToOfferGroupAction
  },
  data() {
    return {
      fileDialog: { dialog: false }
    };
  },
  methods: {
    async showFile(file) {
      const filePreviewSettings = await getFilePreviewSettings(file);
      this.fileDialog = {
        ...filePreviewSettings,
        dialog: true
      };
    },
    async removeGroup() {
      this.$emit("remove", this.group.id);
    }
  }
};
</script>

<style lang="scss"></style>
